import { getResolvedApiSuiteBase } from "@/apiBase";
import { readStoredSuiteUserId } from "@/suiteSession";

export function isSuiteProfilePhotoUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.includes("coffre-profile-photo.php") || url.includes("get-profile-photo.php");
}

/** Script + query uniquement, comme Coffre / Photos (`coffre-profile-photo.php?user_id=&v=`). */
function suitePhotoRelative(url: string): string {
  const normalized = url.replace("get-profile-photo.php", "coffre-profile-photo.php");
  try {
    const parsed = new URL(normalized, "https://local.invalid");
    const q = parsed.search || "";
    const name = parsed.pathname.replace(/^.*\//, "") || "coffre-profile-photo.php";
    return `${name}${q}`;
  } catch {
    const trimmed = normalized.replace(/^\//, "");
    const idx = trimmed.lastIndexOf("coffre-profile-photo.php");
    if (idx >= 0) {
      return trimmed.slice(idx);
    }
    return trimmed;
  }
}

/**
 * Aligné Coffre `coffreResolveProfilePhotoUrl` : préfixe api_suite une fois.
 * Relatif → base ; déjà http(s) → inchangé (idempotent sidebar + profil).
 */
export function resolveChatAvatarUrl(
  url: string | null | undefined,
  suiteUserId?: string | null
): string | null {
  if (!url) return null;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (!isSuiteProfilePhotoUrl(url)) return url;

  const viewer = (suiteUserId || readStoredSuiteUserId() || "").trim();
  let href: string;
  if (/^https?:\/\//i.test(url)) {
    href = url.replace("get-profile-photo.php", "coffre-profile-photo.php");
  } else {
    const base = getResolvedApiSuiteBase()?.replace(/\/$/, "");
    const rel = suitePhotoRelative(url);
    href = base ? `${base}/${rel}` : `/${rel}`;
  }

  try {
    const u = new URL(href, typeof window !== "undefined" ? window.location.origin : "https://local.invalid");
    if (viewer && /^\d+$/.test(viewer) && !u.searchParams.has("suite_user_id")) {
      u.searchParams.set("suite_user_id", viewer);
    }
    return u.toString();
  } catch {
    return href;
  }
}

export function hydrateChatProfileAvatar<T extends { avatar_url?: string | null }>(
  row: T,
  suiteUserId?: string | null
): T {
  return {
    ...row,
    avatar_url: resolveChatAvatarUrl(row.avatar_url, suiteUserId),
  };
}
